import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/config/config';
import { JwtHelper } from 'src/app/services/core/jwt-helper.service';
/** Privacy policy component */
@Component({
	selector: 'app-privacy-policy',
	templateUrl: './privacy-policy.component.html',
	styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
	/** denote whether user is logged in or not */
	isUserLoggedIn = false;
	/**
	 * Privacy policy constructor
	 * @param router - Angular Router
	 * @param jwtHelper - JWT helper Service
	 */
	constructor(
		public config: Config,
		private jwtHelper: JwtHelper
	) {}

	/**
	 * Setting @isUserLoggedIn based on EpmsPID
	 */
	ngOnInit() {
		const epmsId = this.jwtHelper.getEpmsId();
		if (epmsId) {
			this.isUserLoggedIn = true;
		} else {
			this.isUserLoggedIn = false;
		}
	}
}
